import { render, staticRenderFns } from "./inventoryConfiguration.vue?vue&type=template&id=3fe9ca96&"
import script from "./inventoryConfiguration.vue?vue&type=script&lang=js&"
export * from "./inventoryConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports